import React, { useCallback, useEffect, useRef, useState } from 'react';
import { GoCopy } from 'react-icons/go';
import { Link, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { MdCheck } from 'react-icons/md';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { HiCheck } from 'react-icons/hi';
import { AxiosResponse } from 'axios';
import { CgCopy } from 'react-icons/cg';

import api from '~/services/api';
import Toast from '~/utils/toast';

import { Container, Status, Modal } from './styles';
import { IEvent, IEventData } from '..';
import { KrClose, KrEdit, KrEye, KrSearch } from '~/components/KoroIcons';
import Loading from '~/components/Loading';
import Input from '~/components/Input';
import { IoIosPause, IoIosPlay } from 'react-icons/io';
import formatDate from '~/utils/formatDate';
import { addHours, format, parse, parseISO } from 'date-fns';

interface IBatch {
  quantity: number;
}

interface IOrder {
  items: {
    id: number;
    cancelled?: boolean;
  }[];
}

interface IMarketing {
  id: number;
  type: string;
  code: string;
  add_cart: boolean;
  start_payment: boolean;
  checkout: boolean;
}

interface ICard {
  event: IEvent;
  onChangeUnlisted: (event: IEvent) => void;
  onDeleteEvent: (event: IEvent) => void;
  onCopyEvent: (event: IEventData) => void;
}

const Card: React.FC<ICard> = ({
  event: dataEvent,
  onChangeUnlisted,
  onDeleteEvent,
  onCopyEvent,
}) => {
  const formRefMkt = useRef<FormHandles>(null);
  const history = useHistory();
  const [event, setEvent] = useState({} as IEvent);
  const [modalMkt, setModalMkt] = useState(false);
  const [addKart, setAddKart] = useState(true);
  const [startPayment, setStartPayment] = useState(true);
  const [checkout, setCheckout] = useState(true);
  const [analytics, setAnalytics] = useState('');
  const [facebook, setFacebook] = useState('');
  const [loading, setLoading] = useState(false);
  const [marketingData, setMarketingData] = useState({
    analytics_id: 0,
    analytics: '',
    facebook_id: 0,
    facebook: '',
  });
  const [loadingText, setLoadingText] = useState('Carregando...');

  const handleChangeUnlisted = useCallback(
    async (eventData) => {
      await api.patch(`events/organizer/unlisted/${eventData.id}`, {
        unlisted: !eventData.unlisted,
      });

      onChangeUnlisted(eventData);

      Toast.fire({
        icon: 'success',
        iconColor: '#ff6900',
        title: 'Evento alterado com sucesso!',
      });
    },
    [onChangeUnlisted]
  );

  useEffect(() => {
    setEvent(dataEvent);
  }, [dataEvent]);

  const handleClickCopy = useCallback(async (eventData) => {
    await navigator.clipboard.writeText(
      `${process.env.REACT_APP_ATHLETE_URL}/eventos/${eventData.slug}`
    );
    Toast.fire({
      icon: 'success',
      iconColor: '#ff6900',
      title: 'Link copiado para a área de transferência!',
    });
  }, []);

  const handleClickCopyEvent = useCallback(
    async (eventData) => {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ff6900',
        title: `Copiar evento ${eventData.title}?`,
        input: 'text',
        inputPlaceholder: 'Novo nome do evento',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Copiar',
        confirmButtonColor: '#ff6900',
        cancelButtonColor: '#B34A00',
        reverseButtons: true,
        inputValidator: async (value) => {
          if (!value.trim()) {
            return 'Informe um nome para o evento';
          }

          const response = await api.get('events/organizer');

          if (
            response.data.some(
              (eventCopy: any) =>
                eventCopy.name.toLowerCase() === value.trim().toLowerCase()
            )
          ) {
            return 'Já existe um evento com esse nome.';
          }

          return undefined;
        },
        didOpen: () => {
          const confirmButton = Swal.getConfirmButton();
          const input = Swal.getInput();

          confirmButton?.setAttribute('disabled', 'true');

          input?.addEventListener('input', (eventTarget) => {
            const value = (eventTarget.target as HTMLInputElement).value.trim();

            if (value) {
              confirmButton?.removeAttribute('disabled');
            } else {
              confirmButton?.setAttribute('disabled', 'true');
            }
          });
        },
      }).then(async (e) => {
        if (e.isConfirmed) {
          setLoadingText('Copiando evento...');
          setLoading(true);
          try {
            const response = await api.post(
              `events/organizer/copy/${eventData.id}`,
              {
                title: e.value,
              }
            );

            onCopyEvent(response.data);

            Toast.fire({
              icon: 'success',
              iconColor: '#ff6900',
              title: 'Evento copiado com sucesso!',
              timer: 1000,
              willClose: () => {
                window.location.reload();
              },
            });
          } catch (error) {
            Swal.fire({
              icon: 'error',
              title: 'Erro ao copiar evento!',
              text: 'Por favor verifique o nome e tente novamente',
            });
          } finally {
            setLoading(false);
            setLoadingText('Carregando...');
          }
        }
      });
    },
    [onCopyEvent]
  );

  const handleClickSoldOut = useCallback((eventData) => {
    Swal.fire({
      icon: 'warning',
      iconColor: '#ff6900',
      title: `Gostaria de ${
        eventData.status === 'Esgotado' ? 'reabrir' : 'pausar'
      } o evento ${eventData.title} ?`,
      text: `${
        eventData.status === 'Esgotado'
          ? 'Ao reabrir o evento, as vendas serão novamente publicadas.'
          : 'Ao pausar o evento, as vendas serão suspensas até que ele seja novamente reaberto.'
      }`,
      showCancelButton: true,
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim',
      confirmButtonColor: '#ff6900',
      cancelButtonColor: '#B34A00',
      reverseButtons: true,
    }).then(async (e) => {
      if (e.isConfirmed) {
        try {
          const response = await api.patch(
            `events/organizer/toggle/${eventData.id}`
          );

          setEvent({
            ...eventData,
            date: format(
              addHours(parseISO(response.data.date), 3),
              'dd/MM/yyyy'
            ),
            status: response.data.status.name || 'Cadastrando',
          });

          Toast.fire({
            icon: 'success',
            iconColor: '#ff6900',
            title: `Evento ${
              eventData.status === 'Esgotado' ? 'reaberto' : 'pausado'
            } com sucesso!`,
          });
        } catch (error: any) {
          Swal.fire({
            icon: 'error',
            title: '',
            text: error.response?.data?.message || 'Por favor tente novamente',
          });
        }
      }
    });
  }, []);

  const handleClickPublish = useCallback(async (eventData) => {
    try {
      setLoading(true);
      setLoadingText('Carregando...');
      await api.get(`events/organizer/verify/${eventData.id}`);
      Swal.fire({
        icon: 'warning',
        iconColor: '#ff6900',
        title: `${
          eventData.status === 'Em Alteração'
            ? 'Gostaria de publicar o evento?'
            : 'Solicitar a publicação do evento?'
        }`,
        // text: 'Ao solicitar a publicação do evento, o status será alterado para "A Publicar".',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        confirmButtonColor: '#ff6900',
        cancelButtonColor: '#B34A00',
        reverseButtons: true,
      }).then(async (e) => {
        if (e.isConfirmed) {
          if (eventData.status === 'Em Alteração') {
            const response = await api.patch(
              `events/organizer/approve/${eventData.id}`
            );
            setEvent({
              ...eventData,
              status: response.data.status.name,
            });
          } else {
            await api.patch(
              `events/organizer/publication-request/${eventData.id}`
            );

            setEvent({
              ...eventData,
              status: 'A Publicar',
            });
          }

          Toast.fire({
            icon: 'success',
            iconColor: '#ff6900',
            title: `${
              eventData.status === 'Em Alteração'
                ? 'Publicação realizada com sucesso!'
                : 'Solicitação realizada com sucesso!'
            }`,
          });
        }
      });
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || 'Por favor tente novamente';
      Swal.fire({
        icon: 'error',
        title: 'ATENÇÃO - ERRO!',
        html: `<p>${errorMessage
          .replace(/\n/g, '<br>')
          .replace('ATENÇÃO - ERRO!', '')
          .replace('<br>', '')}</p>`,
        confirmButtonText: 'Editar evento',
        confirmButtonColor: '#ff6900',
        width: '800px',
      }).then((e) => {
        if (e.isConfirmed) {
          history.push(
            `${
              process.env.PUBLIC_URL
            }/eventos/${`editar-evento/${eventData.slug}`}`
          );
        }
      });
    } finally {
      setLoading(false);
      setLoadingText('Carregando...');
    }
  }, []);

  const handleClickEditOpen = useCallback(
    (eventData) => {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ff6900',
        title: `Gostaria de editar o evento ${eventData.title}?`,
        text: 'Ao editar o evento, as vendas serão temporariamente pausadas até que as alterações sejam validadas.',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        confirmButtonColor: '#ff6900',
        cancelButtonColor: '#B34A00',
        reverseButtons: true,
      }).then(async (e) => {
        if (e.isConfirmed) {
          await api.patch(`events/organizer/leave-editing/${eventData.id}`);

          history.push(
            `${
              process.env.PUBLIC_URL
            }/eventos/${`editar-evento/${eventData.slug}`}`
          );
        }
      });
    },
    [history]
  );

  const handleClickDelete = useCallback(
    (eventData) => {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ff6900',
        title: `Você está prestes a Excluir definitivamente o Evento ${eventData.title} - Não será possível uma recuperação posterior!`,
        text: 'Deseja realmente excluir?',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        confirmButtonColor: '#ff6900',
        cancelButtonColor: '#B34A00',
        reverseButtons: true,
      }).then(async (e) => {
        if (e.isConfirmed) {
          await api.delete(`events/organizer/${eventData.id}`);
          onDeleteEvent(eventData);
          Toast.fire({
            icon: 'success',
            iconColor: '#ff6900',
            title: 'Evento excluído com sucesso!',
          });
        }
      });
    },
    [onDeleteEvent]
  );

  const handleCloseMkt = useCallback(() => {
    setModalMkt(false);
  }, []);

  const handleSubmitMkt = useCallback(
    async (data) => {
      setLoading(true);

      if (data.analytics) {
        const formData = {
          event_id: event?.id,
          type: 'google_analytics',
          code: data.analytics,
        };

        let response: AxiosResponse;
        if (marketingData.analytics_id) {
          response = await api.put(
            `marketing/${marketingData.analytics_id}`,
            formData
          );
        } else {
          response = await api.post('marketing', formData);
        }

        setMarketingData((oldState) => ({
          ...oldState,
          analytics_id: response.data.id,
          analytics: data.analytics,
        }));
      }

      if (data.facebook) {
        const formData = {
          event_id: event?.id,
          type: 'facebook',
          code: data.facebook,
          add_cart: addKart,
          start_payment: startPayment,
          checkout,
        };

        let response: AxiosResponse;
        if (marketingData.facebook_id) {
          response = await api.put(
            `marketing/${marketingData.facebook_id}`,
            formData
          );
        } else {
          response = await api.post('marketing', formData);
        }

        setMarketingData((oldState) => ({
          ...oldState,
          facebook_id: response.data.id,
          facebook: data.facebook,
        }));

        setEvent((oldState) => ({
          ...oldState,
          has_marketing: true,
        }));
      }

      setLoading(false);
      handleCloseMkt();
    },
    [
      addKart,
      checkout,
      event?.id,
      handleCloseMkt,
      marketingData.analytics_id,
      marketingData.facebook_id,
      startPayment,
    ]
  );

  const handleChangeAnalytics = useCallback((e) => {
    setAnalytics(e.target.value);
  }, []);

  const handleChangeFacebook = useCallback((e) => {
    setFacebook(e.target.value);
  }, []);

  const handleClickMkt = useCallback(async (eventData) => {
    if (eventData.has_marketing) {
      const response = await api.get<IMarketing[]>(
        `marketing/events/${eventData.id}`
      );
      const analyticsData = response.data.find(
        (dataMarketing) => dataMarketing.type === 'google_analytics'
      );

      const marketing = {
        analytics_id: 0,
        analytics: '',
        facebook_id: 0,
        facebook: '',
      };

      if (analyticsData) {
        marketing.analytics_id = analyticsData.id;
        marketing.analytics = analyticsData.code;
        setAnalytics(analyticsData.code);
      }

      const facebookData = response.data.find(
        (dataMarketing) => dataMarketing.type === 'facebook'
      );

      if (facebookData) {
        marketing.facebook_id = facebookData.id;
        marketing.facebook = facebookData.code;

        setFacebook(facebookData.code);
        setAddKart(facebookData.add_cart);
        setStartPayment(facebookData.start_payment);
        setCheckout(facebookData.checkout);
      }

      setMarketingData(marketing);
    }

    setModalMkt(true);
  }, []);

  return (
    <Container className="d-flex bg-white justify-content-between align-items-center p-3 mt-3">
      <div className="w-auto flex-column justify-content-center align-items-center">
        <img src={event.archive_url} alt={event.title} className="default" />
        <p className="text-center mb-0">ID: {event.id}</p>
      </div>
      <div className="w-15">
        <h3 className="mb-1">Nome</h3>
        <p className="mb-0">{event.title}</p>
      </div>
      <div className="w-5">
        <div className="d-flex flex-column align-items-center">
          <img
            src={event.type_image_url}
            alt={event.type}
            className="type-icon"
          />
          <p className="mb-0 text-center">{event.type}</p>
        </div>
      </div>
      <div>
        <h3 className="mb-1">Data do evento</h3>
        <p className="mb-0">{event.date}</p>
      </div>
      <div className="w-10">
        <h3 className="mb-1">Status</h3>
        <Status status={event.status} className="text-center rounded-pill mb-0">
          {event.status === 'Esgotado' ? 'Fim vendas' : event.status}
        </Status>
      </div>
      <div>
        <h3 className="mb-1">Fim das inscrições</h3>
        <p className="mb-0">{event.endRegistration}</p>
      </div>
      <div>
        <h3 className="mb-1">Inscritos</h3>
        <p className="mb-0">{event.purchases}</p>
      </div>
      <div>
        <h3 className="mb-1">Vagas</h3>
        <p className="mb-0">{event.allTickets || 'Ilimitadas'}</p>
      </div>
      <div>
        <h3 className="mb-1">Não listado</h3>
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="flexSwitchCheckDefault"
            checked={event.unlisted}
            disabled={event.status === 'Encerrado'}
            onChange={() => handleChangeUnlisted(event)}
          />
        </div>
      </div>
      <div className="position-relative">
        <button
          type="button"
          className="mkt tooltip-event"
          disabled={
            event.status === 'Encerrado' || event.status === 'Cancelado'
          }
          onClick={() => {
            handleClickMkt(event);
          }}
          data-tooltip="Configure aqui seu Pixel do Facebook e sua tag do Google Analytics para rastrear acessos, carrinhos e vendas no seu evento"
        >
          MKT
        </button>
      </div>

      <div className="w-17 text-end">
        {(event.status === 'Aberto' ||
          event.status === 'Em Andamento' ||
          (event.status === 'Esgotado' &&
            (event.purchases < event.allTickets ||
              event.allTickets === 0))) && (
          <button
            type="button"
            className="position-relative ms-2 border-0 bg-transparent"
            onClick={() => handleClickSoldOut(event)}
          >
            <span
              className="tooltip-event bg-orange rounded-circle"
              data-tooltip={`${
                event.status === 'Esgotado'
                  ? 'Reabrir evento'
                  : 'Parar evento (fim das vendas)'
              }`}
            >
              {event.status === 'Esgotado' ? (
                <IoIosPlay size={16} color="#fff" />
              ) : (
                <IoIosPause size={16} color="#fff" />
              )}
            </span>
          </button>
        )}
        {(event.status === 'Em Alteração' || event.status === 'Rascunho') && (
          <button
            type="button"
            className="publish position-relative ms-2 border-0 bg-transparent"
            onClick={() => handleClickPublish(event)}
          >
            <span
              className="tooltip-event bg-check rounded-circle"
              data-tooltip={`${
                event.status === 'Em Alteração'
                  ? 'Publicação do evento'
                  : 'Solicita ao administrador a publicação do evento'
              }`}
            >
              <MdCheck size={16} color="#000" />
            </span>
          </button>
        )}
        {event.unlisted && (
          <button
            type="button"
            className="position-relative ms-2 border-0 bg-transparent"
            onClick={() => handleClickCopy(event)}
          >
            <span
              className="tooltip-event bg-orange rounded-circle"
              data-tooltip="Copiar link do evento"
            >
              <GoCopy size={16} color="#fff" />
            </span>
          </button>
        )}
        {event.status !== 'Cadastrando' && (
          <>
            <a
              href={`${process.env.REACT_APP_ATHLETE_URL}/eventos/${event.slug}/visualizacao`}
              className="position-relative ms-2 border-0 "
              target="_blank"
              rel="noreferrer"
            >
              <span
                className="tooltip-event bg-orange rounded-circle"
                data-tooltip="Pré-visualização da página do evento (visão do atleta)"
              >
                <KrEye size={16} color="#fff" />
              </span>
            </a>
            <button
              type="button"
              className="ms-2 border-0 position-relative bg-transparent"
              onClick={() => {
                handleClickCopyEvent(event);
              }}
            >
              <span
                className="tooltip-event bg-orange rounded-circle"
                data-tooltip="Copiar evento"
              >
                <CgCopy size={16} color="#fff" />
              </span>
            </button>
          </>
        )}
        <Link
          to={`${process.env.PUBLIC_URL}/eventos/${
            event.status === 'Cadastrando' ||
            event.status === 'Rascunho' ||
            event.status === 'Em Alteração' ||
            event.status === 'Esgotado'
              ? `editar-evento/${event.slug}`
              : `${event.slug}/resumo`
          }`}
          className="ms-2 position-relative border-0"
        >
          {event.status === 'Cadastrando' ||
          event.status === 'Rascunho' ||
          event.status === 'Em Alteração' ? (
            <span
              className="tooltip-event bg-orange rounded-circle"
              data-tooltip="Editar informações do evento"
            >
              <KrEdit size={16} color="#fff" />
            </span>
          ) : (
            <span
              className="tooltip-event bg-orange rounded-circle"
              data-tooltip="Ver resumo das informações do evento"
            >
              <KrSearch size={16} color="#fff" />
            </span>
          )}
        </Link>
        {event.status === 'Aberto' ||
        event.status === 'Esgotado' ||
        event.status === 'Em Andamento' ? (
          <button
            type="button"
            className="ms-2 border-0 position-relative bg-transparent"
            onClick={() => {
              handleClickEditOpen(event);
            }}
          >
            <span
              className="tooltip-event bg-orange rounded-circle"
              data-tooltip="Editar informações do evento aberto"
            >
              <KrEdit size={16} color="#fff" />
            </span>
          </button>
        ) : (
          <button
            type="button"
            className={`${
              event.status === 'Cadastrando' || event.status === 'Rascunho'
                ? 'opacity-100'
                : 'd-none'
            } ms-2 border-0 position-relative bg-transparent`}
            onClick={() => {
              if (
                event.status === 'Cadastrando' ||
                event.status === 'Rascunho'
              ) {
                handleClickDelete(event);
              }
            }}
          >
            <span
              className="tooltip-event bg-orange rounded-circle"
              data-tooltip="Apagar rascunho do evento"
            >
              <KrClose size={16} color="#fff" />
            </span>
          </button>
        )}
      </div>

      <Modal
        className="modal-filter"
        size="lg"
        centered
        show={modalMkt}
        onHide={handleCloseMkt}
      >
        <Form
          ref={formRefMkt}
          initialData={marketingData}
          onSubmit={handleSubmitMkt}
        >
          <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
            <Modal.Title className="mb-0 mt-4">
              <h2 className="title mb-0">Marketing</h2>
            </Modal.Title>
            <button
              type="button"
              onClick={handleCloseMkt}
              className="border-0 bg-transparent"
            >
              <KrClose size={20} color="#989898" />
            </button>
          </Modal.Header>
          <Modal.Body className="pt-0 px-3 px-sm-5">
            <div className="row">
              <div className="col-12">
                <hr />
              </div>

              <div className="col-12">
                <h3 className="h5">Configuração do Google Analytics</h3>
                <span className="h6 fw-normal mt-3 d-block">
                  Código do Google Analytics
                </span>
                <Input
                  type="text"
                  name="analytics"
                  onChange={handleChangeAnalytics}
                />
                <h3 className="h6 fw-normal mt-4">
                  Digite seu código completo, por exemplo G-ABCDE12345
                </h3>
              </div>
              <div className="col-12">
                <hr />
              </div>
              <div className="col-12">
                <h3 className="h5">Configuração Facebook Pixel</h3>
                <span className="h6 fw-normal mt-3 d-block">
                  Número de identificação do Pixel
                </span>
                <Input
                  type="number"
                  name="facebook"
                  onChange={handleChangeFacebook}
                />
                <h3 className="h6 mt-4">
                  Eventos disponíveis para integração:
                </h3>
                <div className="mt-4">
                  <button
                    type="button"
                    disabled={!facebook}
                    onClick={() => setAddKart(!addKart)}
                    className="d-flex check border-0 bg-transparent me-4"
                  >
                    <span className={`${addKart ? 'checked' : ''} me-2`}>
                      {addKart && (
                        <HiCheck
                          size={16}
                          color="#fff"
                          className="check-icon"
                        />
                      )}
                    </span>
                    <span className="text-start">
                      <span className="h6 text-black">
                        Adicionar ao carrinho
                      </span>
                      <br />
                      Será enviado ao facebook quando adicionar uma inscrição ao
                      carrinho
                    </span>
                  </button>
                </div>
                <div className="mt-4">
                  <button
                    type="button"
                    disabled={!facebook}
                    onClick={() => setStartPayment(!startPayment)}
                    className="d-flex check border-0 bg-transparent me-4"
                  >
                    <span className={`${startPayment ? 'checked' : ''} me-2`}>
                      {startPayment && (
                        <HiCheck
                          size={16}
                          color="#fff"
                          className="check-icon"
                        />
                      )}
                    </span>
                    <span className="text-start">
                      <span className="h6 text-black">Iniciar o pagamento</span>
                      <br />
                      Será enviado ao facebook no início da conclusão da compra
                    </span>
                  </button>
                </div>
                <div className="mt-4">
                  <button
                    type="button"
                    disabled={!facebook}
                    onClick={() => setCheckout(!checkout)}
                    className="d-flex check border-0 bg-transparent me-4"
                  >
                    <span className={`${checkout ? 'checked' : ''} me-2`}>
                      {checkout && (
                        <HiCheck
                          size={16}
                          color="#fff"
                          className="check-icon"
                        />
                      )}
                    </span>
                    <span className="text-start">
                      <span className="h6 text-black">
                        Finalização da compra
                      </span>
                      <br />
                      Será enviado ao facebook quando a compra for concluída
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pb-4 px-5">
            <button
              type="submit"
              disabled={!facebook && !analytics}
              className="ms-auto btn-filter d-flex align-items-center justify-content-center border-0 h6 fw-normal py-2 px-5 mt-2 mb-0"
            >
              Salvar
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Loading active={loading} text={loadingText} />
    </Container>
  );
};

export default Card;
